<template>
  <div>
    <div class="header center" :class="{color:color,showMenu:showMenu}" v-show="showbar">
        <img src="../assets/images/nav/logo.png" alt="" class="logo" v-if="index=='1'&&$i18n.locale=='ch'" />
                <img src="../assets/images/nav/logo12.png" alt="" class="logo logo3" v-if="index=='1'&&$i18n.locale=='en'" />
        <img src="../assets/images/nav/logo2.png" alt="" class="logo logo2" v-if="index!='1'"/>
        <span class="menu_icon" v-show="!showMenu" @click="showMenu=true"></span>
        <span class="menu_icon1" v-show="showMenu" @click="showMenu=false"></span>
        <div class="middle">
          <slot></slot>
        </div>
    </div>
    <div class="menu_down" v-if="showMenu">
      <div style="height:100%;overflow-y:scroll">
        <ul class="menu_list">
            <li @click="showMenu=false">
              <router-link to="/" class="menu_link" >{{ $t("header.nav1") }}</router-link>
            </li>
            <li @click="showMenu4=!showMenu4">
              <a  class="menu_link">{{ $t("header.nav11") }}</a>
              <span class="nav_icon_down" :class="{nav_icon_up:showMenu4}"></span>
            </li>
            <li v-if="showMenu4" @click="showMenu=false">
              <router-link to="/product" class="menu_link2">{{ $t("header.nav12") }}</router-link>
            </li>
            <li v-if="showMenu4" @click="showMenu=false">
              <router-link to="/product1" class="menu_link2">{{ $t("header.nav13") }}</router-link>
            </li>
<!--             <li v-if="showMenu4" @click="showMenu=false">
              <router-link to="/product2" class="menu_link2">{{ $t("header.nav14") }}</router-link>
            </li> -->
                        <li v-if="showMenu4" @click="showMenu=false">
              <router-link to="/product3" class="menu_link2">{{ $t("header.nav15") }}</router-link>
            </li>
            <li @click="showMenu3=!showMenu3">
              <a  class="menu_link">{{ $t("header.nav2") }}</a>
              <span class="nav_icon_down" :class="{nav_icon_up:showMenu2}"></span>
            </li>
            <li v-if="showMenu3" @click="showMenu=false">
              <router-link to="/solution" class="menu_link2">{{ $t("header.nav8") }}</router-link>
            </li>
            <li v-if="showMenu3" @click="showMenu=false">
              <router-link to="/solution1" class="menu_link2">{{ $t("header.nav9") }}</router-link>
            </li>
            <li v-if="showMenu3" @click="showMenu=false">
              <router-link to="/solution2" class="menu_link2">{{ $t("header.nav10") }}</router-link>
            </li>
            <li @click="showMenu=false">
              <router-link to="/technology" class="menu_link">{{ $t("header.nav3") }}</router-link>
            </li>
            <li @click="showMenu1=!showMenu1">
              <a  class="menu_link">{{ $t("header.nav4") }}</a>
              <span class="nav_icon_down" :class="{nav_icon_up:showMenu1}"></span>
            </li>
<!--             <li v-if="showMenu1" @click="showMenu=false">
              <router-link to="/software" class="menu_link2">{{ $t("header.nav16") }}</router-link>
            </li> -->
            <li v-if="showMenu1" @click="showMenu=false">
              <router-link to="/devolop" class="menu_link2">{{ $t("header.nav17") }}</router-link>
            </li>
            <li @click="showMenu2=!showMenu2">
              <a  class="menu_link">{{ $t("header.nav5") }}</a>
              <span class="nav_icon_down" :class="{nav_icon_up:showMenu2}"></span>
            </li>
            <li v-if="showMenu2" @click="showMenu=false">
              <router-link to="/about" class="menu_link2">{{ $t("header.nav7") }}</router-link>
            </li>
            <li v-if="showMenu2" @click="showMenu=false">
              <router-link to="/join" class="menu_link2">{{ $t("header.nav6") }}</router-link>
            </li>
        </ul>
        <div class="center">
          <a  class="button2" style="margin:0.46rem 0 1rem 0" @click="free_use()">{{ $t("header.navBtn") }}</a>
          <div class="change_btns">
            <span :class="{gray_btn:$i18n.locale=='en'}" style="padding-right:0.44rem" @click="changeLanguage('ch',$event)">中文</span>/<span style="padding-left:0.44rem" :class="{gray_btn:$i18n.locale=='ch'}" @click="changeLanguage('en',$event)">English</span>
          </div>
        </div>
      </div>

    </div>
    <div v-show="showDialog==true">
       <div class="dialog" >
       <div><span class="closeBtn" @click="showDialog=false;showMenu=false"></span></div>
        <div v-show="!showNext">
            <div >
               <div class="dialog_title" v-html="$t('text1')"></div>
               <div class="dialog_text" style="margin-bottom:0.15rem" v-html="$t('text2')">
                 
               </div>
               <div class="dialog_text" v-html="$t('text3')">
                 
               </div>
               </div>
               <div class="clearfix">
                     <div class="">
                         <ul class="form_list">
                           <li><span class="input_item input_item1">
                            <span class="star">*</span>
                             <span class="input_icon"></span>

                                                         <multiselect
                               
                               :options="options" v-model="content_type2" placeholder="" :searchable="false" :allow-empty="false" v-if="$i18n.locale=='ch'">
                             </multiselect>
                                                         <multiselect
                               
                               :options="options1" v-model="content_type2" placeholder="" :searchable="false" :allow-empty="false" v-if="$i18n.locale=='en'">
                             </multiselect >
                                     <span class="arrow_icon"></span>
                           </span>
                           </li>
                           <li><span class="input_item input_item2">
                             <span class="input_icon"></span>
                             <input type="text" placeholder="公司名称" v-model="company" v-if="$i18n.locale=='ch'">
                             <input type="text" placeholder="Company" v-model="company" v-if="$i18n.locale=='en'">
                           </span></li>
                           <li><span class="input_item input_item3">
                            <span class="star">*</span>
                           <span class="check_success"  v-show="check_ok2=='true'"></span>
                           <span class="check_fail" v-show="check_ok2=='false'"></span>
                             <span class="input_icon"></span>
                             <input type="text" placeholder="姓名" @change='check_success($event,"required")' v-model="name" v-if="$i18n.locale=='ch'">
                             <input type="text" placeholder="Name" @change='check_success($event,"required")' v-model="name" v-if="$i18n.locale=='en'">
                           </span></li>
                           <li><span class="input_item input_item4">
                            <span class="star" v-if="$i18n.locale=='ch'">*</span>
                            <span class="star" v-if="$i18n.locale=='en'"></span>
                           <span class="check_success" v-show="check_ok3=='true'"></span>
                           <span class="check_fail" v-show="check_ok3=='false'"></span>
                             <span class="input_icon" ></span>
                             <input type="text" placeholder="电话" @change='check_success($event,"phone")' v-model="telephone" v-if="$i18n.locale=='ch'">
                             <input type="text" placeholder="Phone" @change='check_success($event,"phone")' v-model="telephone" v-if="$i18n.locale=='en'">
                           </span></li>
                           <li><span class="input_item input_item5">
                            <span class="star">*</span>
                           <span class="check_success" v-show="check_ok4=='true'"></span>
                           <span class="check_fail" v-show="check_ok4=='false'"></span>
                             <span class="input_icon"></span>
                             <input type="email" placeholder="电子邮箱" @change='check_success($event,"email")' v-model="email" v-if="$i18n.locale=='ch'">
                             <input type="email" placeholder="Email" @change='check_success($event,"email")' v-model="email" v-if="$i18n.locale=='en'">
                           </span></li>

                         </ul>

                     </div>

               </div>
               <div style="line-height:0;">
                 <span v-if="showError" style="font-size:0.28rem;color:rgb(255,89,89);">{{errorText}}</span>
                 <br>
                 <a href="javascript:void(0)" class="button2" @click="send_email()" style="width:6.7rem;position:relative;top:0.1rem" v-html="$t('send')">
                   
                 </a>
               </div>
           </div>
           <div v-show="showNext" class="center">
             <img src="../assets/images/dialog/success.png" alt="" style="width:1.6rem;height:1.6rem;padding-top:3.66rem;margin:0 auto">
             <h3 style="font-size:0.36rem;color:rgb(40,40,40);margin:0.4rem 0 0 0rem" v-html="$t('text8')"></h3>
             <h4 style="font-size:0.28rem;color:rgb(80,80,80);margin:0.3rem 0 0 0rem" v-html="$t('text9')"></h4>
             <a href="javascript:void(0)" class="button_default2" style="margin-top:0.7rem" @click="showDialog=false" v-html="$t('text10')"></a>
           </div>

        </div>  
    </div>
  </div>


</template>

<script>
import Vue from 'vue'

// import touchAction from 'touch-action'
import Vue2TouchEvents from 'vue2-touch-events'
  import Bus from './bus.js';
// touchAction()
Vue2TouchEvents.config = {
  maxSingleTapTimeInterval: 200
}

import i18n from '../common/i18n'

Vue.use(Vue2TouchEvents)


import Multiselect from 'vue-multiselect'
export default {
  props:['index','showbar'],
  name: 'index',
  i18n:i18n,
  data () {
    return {
      showMenu:false,
      showMenu1:false,
      showMenu2:false,
      showMenu3:false,
      showMenu4:false,
      showDialog:false,
      options: ['申请使用威尔云', '威尔云服务咨询', '技术疑问','其他'],
      options1: ['Get VRVIU Cloud Trial', 'VRVIU Cloud service questions', 'Technical questions','Others'],
      showweixin:false,
      showNext:false,
      name:"",
      company:"",
      telephone:"",
      email:"",
      content_type2:"申请使用威尔云",
      content_type:1,
      check_ok1:"",
      check_ok2:"",
      check_ok3:"",
      check_ok4:"",
      showError:false,
      errorText:"cdfdfdf",
      color:false
    }
  },
  watch:{
    showMenu(val){
       if(val){
         // window.addEventListener("scroll",function(e){
         //  e.preventDefault();
         // },false)
         if(document.querySelector("video")){
            document.querySelector("video").style.display = "none"
         }
       }else{
        if(document.querySelector("video")){
            document.querySelector("video").style.display = "block"
        }
       }
    },
    showDialog(val){
        if(val){
          document.body.style.position = 'fixed'
        }else{
          document.body.style.position = 'relative'
        }
    },
  },

  mounted () {
      var self = this;
      window.addEventListener("scroll",function(){
        if(document.body.scrollTop>0||document.documentElement.scrollTop>0){
            self.color = true;
        }else{
          self.color = false;
        }
      },false)
      var language = navigator.language; //取得浏览器版本语言
      var initLanguage = "";
      if(localStorage.locale){
        this.$i18n.locale = localStorage.locale;


      }else{
        if (language.indexOf('zh') > -1){
          initLanguage="ch"; //中文页面
        }else if (language.indexOf('en') > -1){
          initLanguage="en"; //英文页面
        }
        this.$i18n.locale = initLanguage;
      }

  },
  methods:{
    changeLanguage(ch){
      this.showMenu = false;
      this.$i18n.locale = ch;
      localStorage.locale = ch;
      this.$emit("on-locale-change",ch);
      Bus.$emit('on-locale-change',this.$i18n.locale);
      if(this.$i18n.locale=="en"){
        if(this.index==1){
            this.setTitile("VRVIU - The Highway to Ultra HD");
        }
        if(this.index==2){
            this.setTitile("Solutions - VRVIU");
        }
        if(this.index==3){
            this.setTitile("Technology - VRVIU");
        }
        if(this.index==7){
            this.setTitile("SDK - VRVIU");
        }

        if(this.index==5){
            this.setTitile("About Us - VRVIU");
        }
        if(this.index==6){
            this.setTitile("Join Us - VRVIU");
        }

      }else{
        if(this.index==1){
            this.setTitile("威尔云VRVIU - 全球领先的高清视频云服务");
        }
        if(this.index==2){
            this.setTitile("解决方案 - 威尔云 VRVIU");
        }
        if(this.index==3){
            this.setTitile("核心技术 - 威尔云 VRVIU");
        }
        if(this.index==4){
            this.setTitile("SDK - 威尔云 VRVIU");
        }

        if(this.index==5){
            this.setTitile("关于我们 - 威尔云 VRVIU");
        }
        if(this.index==6){
            this.setTitile("加入我们 - 威尔云 VRVIU");
        }
      }
    },
    setTitile(t){
      document.title = t;
      var i = document.createElement('iframe');
      i.src = 'https://www.vrviu.com/favicon.ico';
      i.style.display = 'none';
      i.onload = function() {
          setTimeout(function() {
              i.remove();
          }, 9)
      }
      document.body.appendChild(i);
    },
  check_success:function(e,type){
    let el = e.target;
    let value = el.value;
    if(type=="required"){
      if(value==""){
          this.check_ok2 = "false";
      }else{
          this.check_ok2 = "true";
      }
    }else if(type=="phone"&&this.$i18n.locale=='ch'){
      if(value==""){
          this.check_ok3 = "false";
      }else{
        let re =/^1[3|5|8]\d{9}$|^0\d{2,3}-?\d{7,8}$/;
        if(re.test(value)){

          this.check_ok3= "true";
        }else{
          this.check_ok3= "false";
        }
      }
    }else if(type=="email"){
      if(value==""){
        this.check_ok4 = "false";
      }else{
        let re =/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if(re.test(value)){
          this.check_ok4= "true";
        }else{
          this.check_ok4= "false";
        }
      }
    }
  },
  send_email:function(){
    if(this.name==""){
      this.check_ok2="false"
    }
    if(this.telephone==""&&this.$i18n.locale=="ch"){
      this.check_ok3="false"
    }
    if(this.email==""){
      this.check_ok4="false"
    }
    if(this.check_ok2!="false"&&this.check_ok3!="false"&&this.check_ok4!="false"){
      this.showLoding = true;
      var self = this;
      if(this.content_type2=="申请使用威尔云"||this.content_type2=="Get VRVIU Cloud Trial"){
          this.content_type = 1;
      }
      if(this.content_type2=="威尔云服务咨询"||this.content_type2=="VRVIU Cloud service questions"){
          this.content_type = 2;
      }
      if(this.content_type2=="技术疑问"||this.content_type2=="Technical question"){
          this.content_type = 3;
      }
      if(this.content_type2=="其他"||this.content_type2=="Others"){
          this.content_type = 4;
      }

      this.$http.post("https://oth-api.vrviu.com/feedback/",{name:this.name,company:this.company,telephone:this.telephone,email:this.email,content_type:this.content_type,comment:""}).then(
                  function (res) {
                    if(res.body.ret_code == 0){
                        this.showError = false;
                        this.showNext = true;
                    }else{
                      this.showError = true;
                      this.errorText  = res.body.ret_msg;
                    }
                  },function (res) {
                    if(res.status == 503){
                      this.errorText  = this.$t("error503");
                    }else if(res.status == 409){
                      this.errorText  = this.$t("error409");
                    }else{
                      this.errorText  = this.$t("error");
                    }
                      this.showError = true;

                  }
              );
    }
  },
  free_use:function(){
      if(this.$i18n.locale=="en"){
      this.content_type2 ="Get VRVIU Cloud Trial"


    }else{
      this.content_type2 ="申请使用威尔云"

    }
    this.showDialog = true;
    this.showNext=false;
    this.name = "";
    this.company = "";
    this.email = "";
    this.telephone = "";
    this.check_ok1 = "";
    this.check_ok2 = "";
    this.check_ok3 = "";
    this.check_ok4 = "";
    this.showError = false;
  }
  },
  components:{
    Multiselect
  },
  beforeDestroy(){
    // document.querySelector("body").style.overflowY = "scroll";
    document.body.style.position = 'relative'
  }
}
</script>

<style scoped>
.gray_btn{
  color:#686868;
}
.change_btns{
  color:#fff;
  font-size: 0.3rem;
  padding-bottom: 2rem;

}
.button2{
  width: 5.48rem;
  height: 1.2rem;
  background:rgb(0,132,255);
  font-size: 0.36rem;
  display: inline-block;
  text-align: center;
  line-height: 1.22rem;
  border-radius: 0.04rem;
  color:#fff;
  margin: 0 auto;
}
.nav_icon_down{
  display: inline-block;
  width: 0.27rem;
  height:0.15rem;
  background: url(../assets/images/nav/nav_icon_down.png);
  position: absolute;
  right:0;
  top:50%;
  transform: translate(0,-50%);
  background-size: cover;
}
.nav_icon_up{
    display: inline-block;
  width: 0.27rem;
  height:0.15rem;
  position: absolute;
  right:0;
  top:50%;
  transform: translate(0,-50%);
  background: url(../assets/images/nav/nav_icon_up.png);
    background-size: cover;
}
.menu_list{
  margin:0 1.02rem;
  width: 5.48rem;
}
.menu_list li{
  border-bottom:1px solid #353535;
  position: relative;
  height: 1.2rem;
}
.menu_list li .menu_link,.menu_list li .menu_link2{
  font-size: 0.28rem;
  display:inline-block;
  height: 1.2rem;
  line-height: 1.2rem;
  width: 100%;
  color:#fff;
  position: absolute;
  left: 0;
  top:0;
}
.menu_list li .menu_link2{
  text-indent:0.28rem;
  color:#868686
}
.menu_down{
  width: 100%;
  background-color:rgb(33,33,33);
  position: fixed;
  top:1rem;
  left:0;
  z-index:2147483648!important;
  height:100%!important;
  overflow-y:scroll;
}
.logo{
  width: 2.07rem;
  height: 0.45rem;
  padding:0.25rem 0 0 0.23rem;
}
.logo3{
  width: 1.88rem!important;
  height:0.33rem!important;
  padding-top:0.32rem!important;
}
.logo2{
  width:0.72rem;
  height: 0.38rem;
  padding:0.31rem 0 0 0.23rem;
}
.showMenu{
  background:rgba(33,33,33,1)!important;
}
.menu_icon,.menu_icon1{
  display: inline-block;
  width: 0.44rem;
  height: 0.44rem;
  background: url(../assets/images/nav/nav_icon_default.png) no-repeat;
  background-size: cover;
  position: absolute;
  right: 0.32rem;
  top:0.28rem;
}
.menu_icon1{
  height:0.44rem;
  width: 0.44rem;
  background: url(../assets/images/nav/nav_icon_error.png) no-repeat;
    background-size: cover;
}
.header{
  position: fixed;
  width: 100%;
  top:0;
  left:0;
  height: 1rem;
  background:rgba(33,33,33,0.15);
  z-index: 214748364777!important;
  color:#fff;
  font-size: 0.3rem;
}


.dialog_masker{
    height:24rem;
    width: 100%;
    position: fixed;
    left:0;
    z-index: 10000;
    background: rgba(0,0,0,0.6)
}
.dialog_info span{
  color: #ff5959;
  font-size: 0.16rem;
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.2rem;
  text-indent: 1.2rem;
}
.dialog_info{
  text-align: left;
  color:rgb(80,80,80);
  font-size: 0.16rem;
  margin-top: 0.1rem;
  margin-left: 0.6rem;
}
.dialog_footer{
  font-size: 0.16rem;
  color:rgb(160,160,160);
  vertical-align:middle;
  margin-top: 0.3rem;
}
.submitButton{
  width: 2rem;
  height: 0.55rem;
  background: #0084ff;
  border-radius: 0.02rem;
  line-height: 0.5rem;
  color:#fff;
  font-size: 0.24rem;
  text-indent: -0.05rem;
  display: inline-block;
  margin-top: 0.25rem;
}
.textarea2{
  width: 3.92rem;
  height: 2.88rem;
  background: #f7f7f7;
  margin-right: 1rem;
  margin-top: 0.44rem;
}
/*.weixin{
  display: inline-block;
  width: 0.3rem;
  height: 0.22rem;
  background: url(../assets/images/dialog/wechat.png) no-repeat;
  margin-left: 0.3rem;
  vertical-align: middle;
  background-size:cover;
  cursor: pointer;
}*/
.textarea2 textarea{
  border:none;
  background:none;
  height: 0.6rem;
  outline:none;
  width: 3.5rem;
  height: 2.84rem;
  background: url(../assets/images/dialog/icon_5.png) no-repeat;
  margin:0.2rem;
  text-indent: 0.4rem;
  resize: none;
}
.input_item{
  width: 6.62rem;
  height: 0.9rem;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  border: 2px solid #e6e7e9;
  border-radius: 0.04rem;
}
.form_list li span.star{
  color: rgb(255,89,89);
  font-size: 0.28rem;
  vertical-align: middle;
  position: absolute;
  left:0.1rem;
  top:0.1rem;
}
.form_list li{
  margin-bottom:0.38rem;
  width: 100%;
  line-height: 0;
}
.form_list{
  margin:0.7rem auto 0 auto;
  text-align: left;
  width: 6.7rem;
  position: relative;
}
.input_item input,.input_item select{
  font-size:0.28rem;
  -webkit-appearance:none;
  position:absolute; 
  left:0rem;
  top:0rem;
  width: 100%;
  border:none;
  text-align: left;
  background:none;
  padding-left: 1.1rem;
  height: 0.6rem;
  line-height:0.6rem;
  margin-top:0.13rem;
  outline:none;
  color:rgb(80,80,80);
}
.input_item input::-webkit-input-placeholder{
    color:rgb(160,160,160)!important;
    font-size: 0.28rem;
}

.input_icon{
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  background: url(../assets/images/dialog/icon_1.png);
  background-size: contain;
  position: absolute;
  left: 0.4rem;
  top:50%;
  transform: translate(0,-50%);
}
.input_item2 .input_icon{
  background: url(../assets/images/dialog/icon_2.png);
    background-size: contain;
}
.input_item3 .input_icon{
  background: url(../assets/images/dialog/icon_3.png);
    background-size: contain;
}
.input_item4 .input_icon{
  background: url(../assets/images/dialog/icon_4.png);
    background-size: contain;
}
.input_item5 .input_icon{
  background: url(../assets/images/dialog/icon_5.png);
    background-size: contain;
}
.dialog{
  position:fixed;
  top:0;
  left: 50%;
  transform: translate(-50%,0);
  z-index: 2147483647778;
  text-align: center;
  width: 100%;
  height:100%;
  background: #fff;
  border-radius: 0.04rem;
  overflow-y: scroll;
}
.closeBtn{
  display: inline-block;
  height: 0.27rem;
  width: 0.28rem;
  background: url(../assets/images/dialog/icon_close.png);
  position: absolute;
  right:0.4rem;
  top:0.4rem;
  background-size: cover;
}
.english .dialog_title{
  font-family: Quicksand Regular
}
.dialog_title{
  font-size: 0.48rem;
  color:rgb(40,40,40);  
  margin-top: 0.6rem;
  margin-bottom: 0.4rem;
}
.dialog_text{
  font-size: 0.28rem;
  color:rgb(80,80,80);
}
.color{
  background:#212121!important;
}

</style>



// WEBPACK FOOTER //
// header.vue?d697c712